import { useState, useEffect } from "react";
import { createModel } from "hox";
import { offerService } from "../../offerService";
import { IOfferTabEnum, IOfferDetail, IOfferMaterialDetail, IOfferDetailsAdded, IOfferDetailMethod, IOfferExamine, IOfferDescType } from "../../offerTypes";
import useGlobalModel from "@/model/globalModel";
import { message } from "antd";
import { useLockFn } from "ahooks";
import { IMaterialDetail } from "@/views/base/material/materialService";
import { getRandomStr, formatInt, formatNum } from "@/utils/utils";
import moment from "moment";
import { DictCodeEnmu } from "@/types/AppDictEnums";
import { convertRes2Blob } from "@/utils/exportFile";
import { useDictModel } from "@/views/base/dict/dictModel";
import { ILplAuditDetail } from "@/views/ledger/processList/lplService";

//初始加收费用
const initAdded: IOfferDetailsAdded = {
    amount: "0",
    code: "",
    currencyAmount: "0", //币种金额
    ename: "",
    key: "1",
    name: "",
}

//初始收汇方式
const initMethod: IOfferDetailMethod = {
    amount: "0",
    around: "",
    certificatesTime: "",
    code: "",
    collectionTime: "",
    key: "1",
    paymentMethod: "",
    paymentTime: "",
    proportion: "",
}
const initDesc = {
    numAll: 0,
    amountAll: 0,
    auhowAmount: 0,
    upAmountAll: 0,
    saleAmountAll: 0,
    tradeAmountAll: 0,
    ytAmountAll: 0,
    addedAmountAll: 0,
}

export const useOfferDetailModel = createModel(function () {
    const { user: { shopCode, shopName }, beShopDs } = useGlobalModel(({ user, beShopDs }) => [user, beShopDs]);
    const { getTreeNodeValue } = useDictModel();

    const initFormVal = {
        id: "",
        code: "",
        shopName,
        // bentityCode: beShopDs.length > 0 ? beShopDs[0].value : undefined,
        // bentityName: beShopDs.length > 0 ? beShopDs[0].label : undefined,
        rmbAmount: "0",
        goodsAmount: "0",
        addAmount: "0",
        contractAmount: "0",
        exchangeRate: "", //汇率默认1
        //商品信息单价写死的默认值
        auhowPrice: 1.04,
        upPrice: 1.02,
        drawbackAmount: "1.13*0.13",
        ytPrice: 1.01,
        isMiddleman: "0",
    };

    const [tabActive, setTabActive] = useState<IOfferTabEnum>(IOfferTabEnum.BASE_DETAIL) //tabs 选中
    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<IOfferDetail>(initFormVal);
    const [editList, setEditList] = useState<IOfferMaterialDetail[]>([]);
    const [editAddedList, setEditAddedList] = useState<IOfferDetailsAdded[]>([initAdded]);
    const [editMethodList, setEditMethodList] = useState<IOfferDetailMethod[]>([initMethod]);
    const [editDesc, setEditDesc] = useState<IOfferDescType>(initDesc);

    //新增缓存
    const [addFormVal, setAddFormVal] = useState<IOfferDetail>(initFormVal);
    const [addList, setAddList] = useState<IOfferMaterialDetail[]>([]);
    const [addAddedList, setAddAddedList] = useState<IOfferDetailsAdded[]>([]);
    const [addMethodList, setAddMethodList] = useState<IOfferDetailMethod[]>([]);
    const [addDesc, setAddDesc] = useState<IOfferDescType>(initDesc);


    //添加商品弹框
    const [materialDialog, setMaterialDialog] = useState<boolean>(false);
    //导出报价单pdf
    const [offerPdfDialog, setOfferPdfDialog] = useState<boolean>(false);

    //计算商品总计， 和加收费用总计
    // tradeAmountTotal: 0,  //合同总金额  外贸价格总金额sum
    // rmbAmount: 0,   // 人民币金额 云湖总价合计sum
    // addedAmount: 0,   // 加收费用sum
    useEffect(() => {
        let newDesc: IOfferDescType = { ...initDesc };
        editList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.amountAll += Number(item.amount);
            newDesc.auhowAmount += Number(item.auhowAmount);
            newDesc.upAmountAll += Number(item.upAmount);
            newDesc.saleAmountAll += Number(item.saleAmount);
            newDesc.tradeAmountAll += Number(item.tradeAmount);
            newDesc.ytAmountAll += Number(item.ytAmount);
        });
        newDesc.addedAmountAll = editAddedList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0);
        setEditDesc(newDesc);
        updateFormVal("edit", {
            contractAmount: formatNum(clauseChange("edit", editFormVal.clause ?? "", newDesc, editAddedList)),
            rmbAmount: formatNum(newDesc.saleAmountAll),
            goodsAmount: formatNum(newDesc.tradeAmountAll),
            addAmount: formatNum(newDesc.addedAmountAll)
        });
    }, [editList, editAddedList])

    useEffect(() => {
        let newDesc: IOfferDescType = { ...initDesc };
        addList.forEach(item => {
            newDesc.numAll += Number(item.num);
            newDesc.amountAll += Number(item.amount);
            newDesc.auhowAmount += Number(item.auhowAmount);
            newDesc.upAmountAll += Number(item.upAmount);
            newDesc.saleAmountAll += Number(item.saleAmount);
            newDesc.tradeAmountAll += Number(item.tradeAmount);
            newDesc.ytAmountAll += Number(item.ytAmount);
        });
        newDesc.addedAmountAll = addAddedList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0);
        setAddDesc(newDesc);
        updateFormVal("add", {
            contractAmount: formatNum(clauseChange("add", addFormVal.clause ?? "", newDesc, addAddedList)),
            rmbAmount: formatNum(newDesc.saleAmountAll),
            goodsAmount: formatNum(newDesc.tradeAmountAll),
            addAmount: formatNum(newDesc.addedAmountAll)
        });
    }, [addList, addAddedList])

    //汇率失焦
    const exchangeRateChange = (mode: string, exchangeRate: number) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        //修改外贸价格
        //外贸价格 = 云湖销售单价（人民币）/ 汇率
        // setList(origin => origin.map(item => {
        //     let tradePrice = +formatNum(+item.salePrice / +exchangeRate);
        //     return {
        //         ...item,
        //         tradePrice,
        //         tradeAmount: formatNum(+item.num * tradePrice),
        //     }
        // }))
    }

    //获取币种符号
    const getcurrencySymbol = (mode: string) => {
        let currencyCode: string | undefined = mode === "edit" ? editFormVal.currencyCode : addFormVal.currencyCode;
        if (!currencyCode) return ""
        return getTreeNodeValue(currencyCode);
    }

    //添加收汇方式
    const addMethod = (mode: string) => {
        const setMethodList = mode === "edit" ? setEditMethodList : setAddMethodList;
        setMethodList(origin => [...origin, {
            ...initMethod,
            amount: "0.00",
            proportion: "0.00%",
            key: getRandomStr()
        }])
    }

    //添加加收费用
    const addAdded = (mode: string) => {
        const setAddedList = mode === "edit" ? setEditAddedList : setAddAddedList;
        setAddedList(origin => [...origin, {
            ...initAdded,
            key: getRandomStr()
        }])
    }

    //重置页面缓存
    const resetPageCache = (mode: string) => {
        if (mode === "edit") {
            setEditFormVal(initFormVal);
            setEditList([]);
        }
        else if (mode === "add") {
            setAddFormVal(initFormVal);
            setAddList([]);
        }
        setTabActive(IOfferTabEnum.BASE_DETAIL);
    }

    //主单修改
    const updateFormVal = (mode: string, val?: object | null) => {
        const setFormVal = mode === "edit" ? setEditFormVal : setAddFormVal;
        setFormVal((origin: any) => val ? { ...origin, ...val } : initFormVal);
    }

    //商品子表修改
    const updateList = (mode: string, val: IOfferMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList(val);
    }


    /**
   * 根据贸易条款的选择 返回计算好的合同总金额 
     * 合同金额计算 四种情况
     * 1.默认 采购总金额sum + 附加费
     * 2.贸易条款  FOB  采购总金额sum
     * 3.贸易条款  CIF  采购总金额sum + 附加费（只取海运费） 
     * 4.贸易条款  CFR  采购总金额sum + 附加费
   */
    const clauseChange = (mode: string, clasueVal: string, amountAll?: IOfferDescType, addedLists?: IOfferDetailsAdded[]): number => {
        const amounts = amountAll ? amountAll : (mode === "edit" ? editDesc : addDesc);  //附加费
        const addedList = addedLists ? addedLists : (mode === "edit" ? editAddedList : addAddedList);
        let contractAmount: number = 0;

        // 贸易条款  FOB  采购总金额sum
        if (clasueVal === DictCodeEnmu.TRADE_FOB) {
            contractAmount = amounts.tradeAmountAll;
        }
        // 贸易条款  CFR  采购总金额sum + 附加费（只取海运费） 
        else if (clasueVal === DictCodeEnmu.TRADE_CFR) {
            //查询是否存在海运费
            const hyAdded: IOfferDetailsAdded | undefined = addedList.find(item => (item.name ?? "").indexOf("海运费") > -1);
            //取到海运费
            const hyMoney: number = +(hyAdded?.amount ?? 0)
            contractAmount = amounts.tradeAmountAll + hyMoney;
        }
        // CLF  采购总金额sum + 附加费
        // else if (clasueVal === DictCodeEnmu.TRADE_CLF) {
        //     contractAmount = amounts.tradeAmountAll + amounts.addedAmountAll;
        // }
        // 默认 采购总金额sum + 附加费
        else {
            contractAmount = amounts.tradeAmountAll + amounts.addedAmountAll;
        };
        return +formatNum(contractAmount);
    }

    //商品子表添加
    const insertMaterial = (mode: string, arr: IMaterialDetail[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        const formVal: IOfferDetail = mode === "edit" ? editFormVal : addFormVal;
        setList(origin => {
            let newArr: IOfferMaterialDetail[] = [...origin];
            let { auhowPrice, upPrice, drawbackAmount, ytPrice, exchangeRate, isMiddleman } = formVal;  //主单维护的所有单价上浮
            arr.forEach(material => {
                //选中的是否存在列表
                let isExist = origin.find(item => item.materialCode == material.code);
                if (!isExist) {
                    let num = +formatInt(material.num);
                    let price = +formatNum(material.buyingPrice);
                    //欧豪销售单价 = 欧豪销售单价=采购单价*1.04
                    let itemAuhowPrice = +formatNum(price * +auhowPrice);
                    //上浮单价 = 欧豪销售单价 * 1.02
                    let itemUpPrice = +formatNum(itemAuhowPrice * +upPrice);
                    //退税金额 = 欧豪销售单价/1.13*0.13
                    let itemDrawbackAmount = +formatNum(itemAuhowPrice * (1.13 * 0.13));
                    //云湖销售单价 = 上浮单价-退税金额
                    let itemSalePrice = +formatNum(itemUpPrice - itemDrawbackAmount);
                    //云泰单价 = 云湖销售单价*1.01
                    let itemYtPrice = +formatNum(itemSalePrice / + ytPrice);
                    //外贸价格 = 云湖销售单价（人民币）/ 汇率
                    let itemTradePrice = +formatNum((isMiddleman ? itemYtPrice : itemSalePrice) / +(exchangeRate ?? 1));

                    newArr.push({
                        key: material.id,
                        "materialId": material.id,                  // "物料id",
                        "materialCode": material.code,                  // "物料编号",
                        "replaceCode": material.replaceCode,                  // "替换号",
                        "materialName": material.name,                  // "物料名称",
                        "materialEname": material.nameEn,                  // "物料名称英文",
                        "typeCode": material.typeCode,                  // "物料类型",
                        "typeName": material.typeName,                  // "物料类型名称",
                        "unitCode": material.unitCode, // 
                        "unitName": material.unitName, // "单位",
                        "customsCode": material.customsCode, // "海关编码",
                        "num": num,                                      //
                        "price": price,                                  //
                        "amount": +formatNum(num * price),               //
                        "upPrice": itemUpPrice,                          //
                        "upAmount": +formatNum(num * itemUpPrice),       //
                        "auhowPrice": itemAuhowPrice,                    //
                        "auhowAmount": +formatNum(num * itemAuhowPrice), //
                        "drawbackAmount": itemDrawbackAmount,             //
                        "salePrice": itemSalePrice,                      //
                        "saleAmount": +formatNum(num * itemSalePrice),   //
                        "tradePrice": itemTradePrice,                    //
                        "tradeAmount": +formatNum(num * itemTradePrice), //
                        "ytPrice": itemYtPrice,                    //
                        "ytAmount": +formatNum(num * itemYtPrice), //
                        "model": material.model,                  // "规格",
                        "note": "",                             // "备注"
                    })
                }
            });
            return newArr;
        });
        setMaterialDialog(false);
    }

    //商品子表删除
    const removeMaterial = (mode: string, selectedRowKeys: string[]) => {
        const setList = mode === "edit" ? setEditList : setAddList;
        setList(origin => origin.filter(item => selectedRowKeys.indexOf(item.key) < 0));
    }

    //获取一条数据
    const getOfferDetailOne = async (id: string) => {
        let { retData } = await offerService.one(id);
        let { details, detailsAdd, detailsPayment, ...formVal } = retData;
        if (retData) {
            detailsAdd = detailsAdd ?? []
            detailsPayment = detailsPayment ?? []
            setEditFormVal({
                ...initFormVal,
                ...formVal,
                contractAmount: formatNum(formVal.contractAmount),
                offerTime: formVal.offerTime ? moment(formVal.offerTime) : null,
                termTime: formVal.termTime ? moment(formVal.termTime) : null,
                createTime:formVal.createTime ?moment(formVal.createTime):null,
                updateTime:formVal.updateTime ?moment(formVal.updateTime):null,
                batches: formVal.batches === "1" ? true : false, // "分批",
                transship: formVal.transship === "1" ? true : false,// "转船",
                // isMiddleman: formVal.isMiddleman === "1" ? true : false
            });
            setEditList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
            //加收费用  收汇方式  空初始一条数据
            setEditAddedList(detailsAdd.length > 0 ? detailsAdd.map(item => ({ ...item, key: item.id ?? "" })) : [initAdded]);
            setEditMethodList(detailsPayment.length > 0 ? detailsPayment.map(item => ({
                ...item,
                key: item.id ?? "",
                // paymentTime: item.paymentTime ? moment(item.paymentTime) : null,
                collectionTime: item.collectionTime ? moment(item.collectionTime) : null,
                certificatesTime: item.certificatesTime ? moment(item.certificatesTime) : null,
            })) : [initMethod]);
        }
        return retData;
    };

    //更新商品详情
    const getOfferDetailOneGoods = async () => {
        let { retData } = await offerService.one(editFormVal.id);
        let { details } = retData;
        if (retData) {
            setEditList(details?.map(item => ({ ...item, key: item.id ?? "" })) ?? []);
        }
    };

    //报价单新增 | 编辑
    const insertOrUpdateOffer = useLockFn(async (mode: string, formVal: IOfferDetail, refresh = true) => {
        // debugger;
        const materialList = mode === "edit" ? editList : addList;
        const detailsAdd = mode === "edit" ? editAddedList : addAddedList;
        const detailsPayment = mode === "edit" ? editMethodList : addMethodList;
        const formV = mode === "edit" ? editFormVal : addFormVal;
        let data = {
            ...formV,
            ...formVal,
            shopCode,
            offerTime: formVal.offerTime instanceof Object ? formVal.offerTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            termTime: formVal.termTime instanceof Object ? formVal.termTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            createTime:formVal.createTime instanceof Object ? formVal.createTime.format('YYYY-MM-DDTHH:mm:SS') :null,
            updateTime:formVal.updateTime instanceof Object ? formVal.updateTime.format('YYYY-MM-DDTHH:mm:SS') :null,
            batches: formVal.batches ? "1" : "0", // "分批",
            transship: formVal.transship ? "1" : "0", // "转船",
            // isMiddleman: formVal.isMiddleman ? "1" : "0",
            details: materialList,
            detailsAdd,
            //收汇方式 处理日期
            detailsPayment: detailsPayment.map(item => ({
                ...item,
                // paymentTime: item.paymentTime instanceof Object ? item.paymentTime.format('YYYY-MM-DDTHH:mm:ss') : null,
                collectionTime: item.collectionTime instanceof Object ? item.collectionTime.format('YYYY-MM-DDTHH:mm:ss') : null,
                certificatesTime: item.certificatesTime instanceof Object ? item.certificatesTime.format('YYYY-MM-DDTHH:mm:ss') : null,
            }))
        };
        //新增
        if (mode === "edit") {
            let { retData } = await offerService.update({ ...data, id: editFormVal.id, code: editFormVal.code ?? "" });
            refresh && getOfferDetailOne(editFormVal.id)
            refresh && message.success("编辑成功")
            return retData;
        } else {
            let { retData } = await offerService.insert(data);
            message.success("新增成功,自动转换至编辑详情页")
            return retData;
        }
    })

    //提交审核
    const submitOffer = useLockFn(async (id: string) => {
        //校验收汇方式的金额合计 === 主单的
        const methodTotalAmount = editMethodList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0);
        if (methodTotalAmount !== +(editFormVal.contractAmount ?? 0)) {
            message.warning("收汇方式的金额合计与主单的合同总金额不一致，请修改后重新保存");
            return false
        }
        let formRes = await insertOrUpdateOffer("edit", editFormVal, false);
        let { retData } = await offerService.submitOffer(id);
        getOfferDetailOne(editFormVal.id)
        message.success("提交审核成功");
        return retData;
    })
    //总监审核
    const examineManager = useLockFn(async (obj: IOfferExamine) => {
        let { retData } = await offerService.examineManager(obj);
        getOfferDetailOne(editFormVal.id)
        message.success("已提交总监审核");
        return retData;
    })
    //财务审核
    const examineReckoner = useLockFn(async (obj: IOfferExamine) => {
        let { retData } = await offerService.examineReckoner(obj);
        getOfferDetailOne(editFormVal.id)
        message.success("已提交财务审核");
        return retData;
    })
    //转外贸合同
    const transferOffer = useLockFn(async () => {
        let { retData } = await offerService.transferOffer({
            shopCode,
            code: editFormVal.code
        });
        message.success("转外贸合同成功,自动转接到外贸合同详情");
        return retData;
    })
    //作废
    const disableOffer = useLockFn(async () => {
        let { retData } = await offerService.disable(editFormVal.code);
        getOfferDetailOne(editFormVal.id);
        message.success("作废成功")
    })
    //导出商品
    const materialExport = async () => {
        let result = await offerService.materialExport({ shopCode, code: editFormVal.code });
        let fileName: string = `${editFormVal.code}-${moment().format("YYYY-MM-DD")}.pdf`;
        // convertRes2Blob(result, fileName);
        getOfferDetailOne(editFormVal.id)
    }
    //导出商品excel
    const materialExportExcel = async () => {
        let result = await offerService.materialExportExcel({ shopCode, code: editFormVal.code });
        convertRes2Blob(result);
        getOfferDetailOne(editFormVal.id)
    }
    //添加供应商报价信息弹框
    const [supplierDialog, setSupplierDialog] = useState<boolean>(false);

    /**
     * 判断是否可以编辑
     * @param mode 
     * @returns 
     */
    const isDisabeld = (mode: string) => {
        if (mode === "edit") {
            return new Set([DictCodeEnmu.QUOTE_CANCEL, DictCodeEnmu.QUOTE_FINISH, DictCodeEnmu.QUOTE_PEND_SETTLE]).has(editFormVal.status as DictCodeEnmu)
        }
        return false
    }

    //下载导入详情模板
    const downloadSupplierTpl = async () => {
        let result = await offerService.downloadSupplierTpl(editFormVal.supplierOfferCode ?? "", shopCode);
        convertRes2Blob(result);
    }

    return {
        /***field***/
        editFormVal,
        editList,
        addFormVal,
        addList,
        initAdded,
        initMethod,
        addDesc,
        editDesc,
        tabActive, setTabActive,
        materialDialog, setMaterialDialog,
        supplierDialog, setSupplierDialog,
        editMethodList, setEditMethodList,
        editAddedList, setEditAddedList,
        addMethodList, setAddMethodList,
        addAddedList, setAddAddedList,
        offerPdfDialog, setOfferPdfDialog,
        /***method***/
        getOfferDetailOne, submitOffer, examineManager, examineReckoner,
        updateFormVal,
        updateList,
        removeMaterial,
        insertMaterial,
        insertOrUpdateOffer,
        resetPageCache,
        addMethod,
        addAdded,
        transferOffer,
        exchangeRateChange,
        clauseChange,
        materialExport,
        materialExportExcel,
        disableOffer,
        getcurrencySymbol,
        isDisabeld,
        getOfferDetailOneGoods,
        setEditList,
        setAddList, downloadSupplierTpl,
        
    }
});